export default __webpack_public_path__ + "static/media/V410_B_BD.d1fe5625.pdf";